import Vue from 'vue'
import { Message } from 'element-ui'

function FpsMessage(options) {
  let config = {}
  if (typeof options === 'string') {
    config.message = options
  } else {
    config = {
      ...options
    }
  }
  return Message(config)
}

['success', 'error', 'info', 'warning', 'confirm'].forEach(type => {
  FpsMessage[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options
      }
    }

    options.type = type

    return FpsMessage(options)
  }
})

Vue.prototype.$message = FpsMessage

export default FpsMessage
